export class BaseStoreSession {
}
//# sourceMappingURL=base-session.abstract.js.map